import WeekendDateModel from "./model";
import styled from "styled-components";
import { grey_6, grey_4 } from "assets/strings/colors";

const WeekendDate = styled(WeekendDateModel)`
  #root & {
    margin: 0;
    padding: 1rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${grey_4};
    > label {
      margin: 0;
      font-weight: bold;
    }

    > p {
      margin: 0;
      font-weight: bold;
    }

    > div {
      width: 46%;

      > .react-datepicker__input-container {
        width: 100%;

        > input {
          width: calc(100% - 16px);
          border: none;
          border-radius: 1rem;
          color: ${grey_6};
          font-size: 1.2rem;
          margin: 0;
          text-align: center;
          outline: none;
          box-shadow: none;
          transition: box-shadow 250ms linear;

          :focus {
            box-shadow: 0 1px darkgrey;
          }
        }

        > .react-datepicker__close-icon::after {
          right: 0;
        }
      }

      > .react-datepicker-wrapper {
        width: 100%;

        > .react-datepicker__input-container {
          width: 100%;

          > input {
            margin: 0;
            width: calc(100% - 16px);
            border: none;
            border-radius: 1rem;
            color: ${grey_6};
            font-size: 1.2rem;
            text-align: center;
            outline: none;
            box-shadow: none;
            transition: box-shadow 250ms linear;

            :focus {
              box-shadow: 0 1px darkgrey;
            }
          }

          > .react-datepicker__close-icon::after {
            right: 15px;
          }
        }
      }
    }

    > div:last-child {
      > .react-datepicker-popper {
        > .react-datepicker {
          > .react-datepicker__triangle {
            right: 50px;
            left: auto;
          }
        }
      }
    }
    @media (max-width: 950px) {
      justify-content: center;
    }
  }
`;

export default WeekendDate;
